import { loginConstants } from '../actions/constants/loginConstants';

const initialAccounts = {
	isSuccess: false,
	status: "",
	loginInput: {
		userName: "",
		password: "",
		isRememberMe: false,
		userAgent:""
	},
	forgetPwdInput: {
		userId: 0,
		oldPassword: "",
		newPassword: "",
		token: "",
		changePwd: false
	},
	info: {
		id: 0,
		userName: "",
		email: "",
		joinedDate: new Date(),
		isFirstTimeLogin: false,
		deleted: false,
		isRememberMe: false,
		isLoginByRefreshToken:false
	},
	accessToken: "",
	refreshToken: "",
	expiredAtUtc: "",
	error: '',
};


const loginData = (state = initialAccounts, action: any) => {
	switch (action.type) {
		case loginConstants.LoginGetDetailRequest:
			return {
				...state,
				isLoading: true,	
				isLoggedIn:false,
				isSuccess: false,
				isError: false
			};
		case loginConstants.LoginGetDetailSuccess:
			return {
				...state,
				isLoading: false,
				isLoggedIn: true,
				isSuccess: action.payload.isSuccess,
				isError: false,
				sessionTimeout: action.payload.sessionTimeout,
				status: action.payload.status,
				info: action.payload.user,
				accessToken: action.payload.accessToken,
				refreshToken: action.payload.refreshToken,
				expiredAtUtc: action.payload.expiredAtUtc,
				loginByRefreshToken:false
			};
		case loginConstants.LoginGetDetailFailure:
			return {
				...state,
				isLoading: false,
				isLoggedIn: false,
				isSuccess: false,
				error: action.payload,
				isError: true
			};
		case loginConstants.LogoutGetDetailRequest:
			return {
				...state,
			};
		case loginConstants.LogoutGetDetailSuccess:
			return {
				...state,
			};
		case loginConstants.LogoutGetDetailFailure:
			return {
				...state,
			};

		case loginConstants.CheckLoggedUserRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case loginConstants.CheckLoggedUserSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
			};
		case loginConstants.CheckLoggedUserFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true
			};

		case loginConstants.ForgotPasswordRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				input: action.input,
				status: initialAccounts.status,
			};
		case loginConstants.ForgotPasswordSuccess:
			return {
				...state,
				isLoading: false,
				status: action.payload.status,
				isError: false,
				isSuccess: true
			};
		case loginConstants.ForgotPasswordFailure:
			return {
				...state,
				isLoading: false,
				status: action.payload,
				isError: true
			};
		case loginConstants.ForgotPasswordCheckTokenRequest:
			return {
				...state,
				isLoading: true,
				input: action.input,
				isError: false,
				isSuccess: false,
				status: initialAccounts.status,
			};
		case loginConstants.ForgotPasswordCheckTokenSuccess:
			return {
				...state,
				isLoading: false,
				status: action.payload.status,
				isError: false,
				isSuccess: true
			};
		case loginConstants.ForgotPasswordCheckTokenFailure:
			return {
				...state,
				isLoading: false,
				status: action.payload,
				error: action.payload,
				isError: true
			};
		case loginConstants.ForgotPasswordChangeRequest:
			return {
				...state,
				isLoading: true,
				status: initialAccounts.status,
				input: action.input,
				isError: false,
				isSuccess: false
			};
		case loginConstants.ForgotPasswordChangeSuccess:
			return {

				...state,
				isLoading: false,
				changPWDstatus: action.payload,
				isError: false,
				isSuccess: true
			};
		case loginConstants.ForgotPasswordChangeFailure:
			return {
				...state,
				isLoading: false,
				status: action.payload,
				isError: true
			};

		case loginConstants.FrontAppCheckTokenRequest:
			return {
				...state,
				isLoading: true,
				input: action.input,
				isError: false,
				isSuccess: false,
				isValidToken: false,
				status: initialAccounts.status,
			};
		case loginConstants.FrontAppCheckTokenSuccess:
			return {
				...state,
				isLoading: false,
				status: action.payload.status,
				isValidToken: action.payload.isSuccess,
				isError: false,
				isSuccess: true
			};
		case loginConstants.FrontAppCheckTokenFailure:
			return {
				...state,
				isLoading: false,
				status: action.payload,
			}
		case loginConstants.GetUserByRefreshTokenRequest:
			return {
				...state,
				isLoading: true,
				isRememberMeLoggedIn: false,
				isSuccess: false,
				isError: false
			};
		case loginConstants.GetUserByRefreshTokenSuccess:
			return {
				...state,
				isLoading: false,
				isRememberMeLoggedIn: true,
				isSuccess: action.payload.isSuccess,
				isError: false,
				sessionTimeout: action.payload.sessionTimeout,
				status: action.payload.status,
				loginInput: action.input,
				info: action.payload.user,
				accessToken: action.payload.accessToken,
				refreshToken: action.payload.refreshToken,
				expiredAtUtc: action.payload.expiredAtUtc,
				loginByRefreshToken:true
			};
		case loginConstants.GetUserByRefreshTokenFailure:
			return {
				...state,
				isLoading: false,
				isRememberMeLoggedIn: false,
				isSuccess: false,
				isError: true,
				loginByRefreshTokenFailed: true
			};
		default:
			return state;
	}
};

export default loginData;
